// src/pages/Aviso.js
import React, { useState } from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { Modal, Button } from 'react-bootstrap';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '../styles/Aviso.css';

const pdfjsVersion = '3.0.279';
const pdfFile = "/aviso.pdf";

const Aviso = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className="container mt-5 d-flex flex-column align-items-center">
      <h1>Aviso de Privacidad</h1>

      {/* Pequeña vista previa del PDF */}
      <div className="pdf-container" onClick={handleShow} style={{ cursor: 'pointer' }}>
        <Worker workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjsVersion}/build/pdf.worker.min.js`}>
          <Viewer fileUrl={pdfFile} />
        </Worker>
      </div>

      {/* Botón de descarga */}
      <a className="btn btn-primary mt-4" href={pdfFile} download="aviso.pdf">
        Descargar PDF
      </a>

      {/* Modal con visor de PDF en tamaño grande */}
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Body>
          <div className="pdf-modal-content d-flex justify-content-center align-items-center">
            <Worker workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjsVersion}/build/pdf.worker.min.js`}>
              <Viewer fileUrl={pdfFile} />
            </Worker>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Aviso;
